import gql from 'graphql-tag';

// Comments v3 (plan 1): a done thread is open again.
export default gql`
mutation deletePageCommentResolution($commentId: Int!) {
  delete_page_comment_resolutions_by_pk(comment_id: $commentId) {
    comment_id
  }
}
`;
